import React, { Component } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import Chip from "@mui/material/Chip";
import DataStore from "./../../../stores/DataStore";
import { observer } from "mobx-react";

/**
 * @class
 * TagEdit zur Auswahl mehrerer Einträge aus einem DropDown Menü
 * @name MultiChoice
 * @implements {Attribute}
 */
class MultiChoice extends Component {
  onChange(evt) {
    const { attribute: { onChange } = {} } = this.props;
    onChange(evt.target.value);
  }

  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = [] } = DataStore.attributeValues[this.id];
    return `[${value.join()}]`;
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  getFields() {
    const { attribute: { attributeOption = {}, requestKey } = {} } = this.props;
    const { choices = [] } = attributeOption;
    if (requestKey) {
      return this.createFields(
        DataStore.requestStore.requests[requestKey].value
      );
    }
    return this.createFields(choices);
  }

  createFields(pChoices) {
    const { attribute: { attributeOption = {}, id = "" } = {} } = this.props;
    const { choices = [] } = attributeOption;
    let usedChoices = [];
    if (pChoices) usedChoices = pChoices;
    else usedChoices = choices;
    const choicesList = [];
    usedChoices.forEach((c) => {
      choicesList.push(
        <MenuItem value={c.value} key={id + c.value}>
          {c.label}
        </MenuItem>
      );
    });
    return choicesList;
  }

  /**
   * @render
   */
  render() {
    const {
      attribute: {
        id = "",
        name = "",
        attributeOption: {
          FormCtrl = FormControl,
          InputL = InputLabel,
          SelectC = Select,
          FormLabelProps = {},
          InputLabelProps = {},
          SelectProps = {},
        },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;

    if (typeof DataStore.attributeValues[this.id].value !== typeof []) {
      DataStore.attributeValues[this.id].setValue([]);
    }

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };
    return (
      <FormCtrl
        {...FormLabelProps}
        style={{
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          flexGrow: 1,
          marginRight: "5px",
        }}
      >
        <InputL {...InputLabelProps} id="demo-mutiple-chip-label">
          {name}
        </InputL>
        <SelectC
          labelId="demo-mutiple-chip-label"
          id="demo-mutiple-chip"
          disabled={DataStore.attributeValues[this.id].readOnly}
          InputLabelProps={{ shrink: true }}
          multiple
          value={DataStore.attributeValues[this.id].value || ""}
          onChange={(evt) => this.onChange(evt)}
          input={<Input id="select-multiple-chip" />}
          renderValue={(selected) => (
            <div>
              {selected.map((val) => (
                <Chip key={val} label={val} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
          {...SelectProps}
        >
          {this.getFields()}
        </SelectC>
      </FormCtrl>
    );
  }
}

export default observer(MultiChoice);
